import React, { useState } from 'react';
import { useTheme } from "../contexts/ThemeContext";
import { authFetch } from '../utils/api';
import { THEMES, THEME_COLORS } from './Constants';

export default function PasswordChangeModal ({ onClose, notify }) {
    const [passwords, setPasswords] = useState({
        current: '',
        new: '',
        confirm: ''
    });
    const [isSaving, setIsSaving] = useState(false);

    // Récupération du thème (Hook en haut !)
    const { currentTheme } = useTheme();
    const themeColors = THEME_COLORS[currentTheme] || THEME_COLORS[THEMES.BLUE];
    

    const handleChange = (e) => {
        setPasswords({ ...passwords, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // 1. Validation basique
        if (passwords.new !== passwords.confirm) {
            return notify("Les nouveaux mots de passe ne correspondent pas.", "error");
        }
        if (passwords.new.length < 6) {
            return notify("Le nouveau mot de passe doit faire au moins 6 caractères.", "warning");
        }

        setIsSaving(true);
        try {
            const response = await authFetch.put('/api/user/update-password', {
                currentPassword: passwords.current,
                newPassword: passwords.new
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || "Erreur lors du changement de mot de passe.");
            }

            notify("Mot de passe modifié avec succès !", "success");
            onClose();
        } catch (err) {
            notify(err.message, "error");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div style={styles.modalOverlay}>
            <div style={{ ...styles.modalContent, backgroundColor: themeColors.mainBackground, maxWidth: '400px' }}>
                <h3 style={{ color: themeColors.text, marginTop: 0 }}>Changer le mot de passe</h3>
                
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div>
                        <label style={styles.label}>Mot de passe actuel :</label>
                        <input 
                            name="current"
                            type="password" 
                            style={{ ...styles.input(themeColors), width: '100%' }} 
                            value={passwords.current}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <hr style={{ border: '0', borderTop: `1px solid ${themeColors.inputBorder}`, margin: '5px 0' }} />

                    <div>
                        <label style={styles.label}>Nouveau mot de passe :</label>
                        <input 
                            name="new"
                            type="password" 
                            style={{ ...styles.input(themeColors), width: '100%' }} 
                            value={passwords.new}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div>
                        <label style={styles.label}>Confirmer le mot de passe :</label>
                        <input 
                            name="confirm"
                            type="password" 
                            style={{ ...styles.input(themeColors), width: '100%' }} 
                            value={passwords.confirm}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                        <button 
                            type="button" 
                            onClick={onClose} 
                            style={{ ...styles.cancelButton, backgroundColor: themeColors.defaultButton, color: themeColors.textSecondary }}
                        >
                            Annuler
                        </button>
                        <button 
                            type="submit" 
                            disabled={isSaving}
                            style={{ ...styles.saveButton(themeColors), backgroundColor: themeColors.success }}
                        >
                            {isSaving ? "Modification..." : "Valider"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const styles = {
    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000, // Supérieur au reste pour bloquer l'interaction
        backdropFilter: "blur(2px)",
    },
    modalContent: {
        padding: "30px",
        borderRadius: "12px",
        width: "90%",
        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
        position: "relative",
    },
    label: {
        fontWeight: "bold",
        marginBottom: "8px",
        display: "block",
        fontSize: "0.9em",
    },
    input: (colors) => ({
        padding: "10px",
        borderRadius: "6px",
        border: `1px solid ${colors.inputBorder}`,
        backgroundColor: colors.inputBackground,
        color: colors.text,
        fontSize: "1em",
        boxSizing: "border-box",
        outline: "none",
    }),
    saveButton: (colors) => ({
        padding: "10px 20px",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "bold",
        color: colors.textSecondary,
        transition: "transform 0.1s, opacity 0.2s",
    }),
    cancelButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "bold",
        transition: "background-color 0.2s",
    }
};